// Mission tier and game data definitions

export const missionsData = {
  tiers: {
    easy: {
      color: '#10b981',
      label: 'Fácil',
      icon: '🟢'
    },
    medium: {
      color: '#f59e0b',
      label: 'Medio',
      icon: '🟡'
    },
    hard: {
      color: '#ef4444',
      label: 'Difícil',
      icon: '🔴'
    },
    epic: {
      color: '#8b5cf6',
      label: 'Épico',
      icon: '🟣'
    },
    legendary: {
      color: '#f97316',
      label: 'Legendario',
      icon: '🟠'
    }
  },

  // Mission reward types
  rewardTypes: {
    coins: { icon: '💰', label: 'Monedas' },
    xp: { icon: '⭐', label: 'Experiencia' },
    items: { icon: '🎒', label: 'Objetos' }
  },

  // Requirement types
  requirementTypes: {
    level: { icon: '🔢', label: 'Nivel' },
    strength: { icon: '💪', label: 'Fuerza' },
    agility: { icon: '🏃', label: 'Agilidad' },
    intellect: { icon: '🧠', label: 'Intelecto' },
    coins: { icon: '💰', label: 'Monedas' },
    item: { icon: '🎒', label: 'Objeto' }
  },

  // Cities (will be loaded from API but we have fallback data)
  cities: {
    default: {
      name: 'Ciudad Desconocida',
      biome: 'unknown',
      missions: []
    }
  },

  // Mission status
  status: {
    ACTIVE: { label: 'Activa', icon: '⏳', color: '#3b82f6' },
    COMPLETED: { label: 'Completada', icon: '✅', color: '#10b981' },
    CLAIMED: { label: 'Reclamada', icon: '🎁', color: '#6b7280' },
    CANCELED: { label: 'Cancelada', icon: '❌', color: '#ef4444' }
  }
};